import Component from '@glimmer/component';
import { computed } from '@ember/object';

export default class MwChatTime extends Component {
  @computed('args.date')
  get datetime() {
    return new Date(this.args.date * 1000).toISOString();
  }
}
